import { fromJS } from 'immutable'

export const demoReveal = fromJS([{
  "reveal": {
    "name": "ABC Corp",
    "location": "3 Copley Pl, Boston, MA",
    "type": "private",
    "domain": "drift.com",
    "description": "ABC Corp is your social media marketing platform built on social analytics, community engagement and governance for Facebook, Twitter, LinkedIn, and Instagram.",
    "url": "http://drift.com",
    "tags": [
      "SAAS",
      "Technology",
      "B2B",
      "Information Technology & Services"
    ],
    "tech": [
      "google_tag_manager",
      "mandrill",
      "wordpress",
      "google_apps",
      "cloud_flare",
      "marketo",
      "sendgrid",
      "google_analytics",
      "zendesk",
      "intercom",
      "adroll"
    ],
    "logo": "https://logo.clearbit.com/falcon.io",
    "facebook": {
      "handle": "drifthq"
    },
    "geo": {
      "city": "Boston",
      "state": null,
      "stateCode": null,
      "country": "United States",
      "countryCode": "DK",
      "lat": 55.674143,
      "lng": 12.571747
    },
    "github": null,
    "twitter": {
      "handle": "abccorp",
      "id": "395350496",
      "bio": "We're a unified customer experience platform for social media listening, engagement, publishing, analytics & customer data management. #socialmedia #custexp",
      "followers": 13454,
      "following": 6719,
      "location": "Boston, MA",
      "site": "https://t.co/PLYR7m8Fdw",
      "avatar": "https://pbs.twimg.com/profile_images/884466889786896384/ENsvoSrS_normal.jpg"
    },
    "linkedin": {
      "handle": null
    },
    "googleplus": null,
    "angellist": null,
    "customer": null,
    "crunchbase": {
      "handle": "organization/falcon-social"
    },
    "metrics": {
      "raised": 23700000,
      "employees": 240,
      "googleRank": 0,
      "alexaUsRank": 23273,
      "alexaGlobalRank": 59233,
      "marketCap": 0
    },
    "category": {
      "sector": "Information Technology",
      "industryGroup": "Software & Services",
      "industry": "Internet Software & Services",
      "subIndustry": "Internet Software & Services"
    },
    "dumbScore": 13454
  },
  "madkudu": {
    "segment": "very good",
    "top_signals": [
      {
        "name": "capital raised",
        "value": 23700000,
        "type": "positive"
      },
      {
        "name": "employee count",
        "value": 240,
        "type": "positive"
      },
      {
        "name": "based in a country where gdp per capita",
        "value": "high",
        "type": "positive"
      },
      {
        "name": "belongs to industry where revenue per employee",
        "value": "high",
        "type": "positive"
      },
      {
        "name": "number of tech found on website",
        "value": 12,
        "type": "positive"
      },
      {
        "name": "web traffic volume",
        "value": "medium",
        "type": "positive"
      },
      {
        "name": "company founding year",
        "value": 2010,
        "type": "positive"
      }
    ]
  },
  "account": {
    "accountId": "bb840014-3be7-416f-9ee6-b1a6bd069723",
    "name": "ABC Corp",
    "domain": "drift.com",
    "orgDomainLookup": "drift.com",
    "ownerId": 143868,
    "orgId": 1,
    "deleted": false,
    "createDateTime": 1520317012312,
    "updateDateTime": 1520317012312,
    "targeted": true,
  }
}])



// WEBPACK FOOTER //
// ./src/scripts/app/modules/reveal/demodata.js